import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const companyInfo = [
  { label: '会社名', value: 'Hug' },
  { label: '所在地', value: '鳥取県' },
  { label: '代表者', value: '金谷千紘' },
  { label: '設立', value: '—' },
  { label: '事業内容', value: 'ベビー服事業' },
];

export default function CompanySection() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: tableRef, isVisible: tableVisible } = useScrollAnimation();

  return (
    <section id="company" className="py-28 px-6 bg-[#F9F5EF]">
      <div className="max-w-3xl mx-auto">
        <div
          ref={headerRef}
          className={`text-center mb-16 fade-in ${headerVisible ? 'visible' : ''}`}
        >
          <p className="text-[#C97B7B] text-xs tracking-[0.4em] mb-4 uppercase">Company</p>
          <h2 className="text-[#3A2E28] text-3xl md:text-4xl font-light mb-4" style={{ fontFamily: 'Noto Serif JP, serif' }}>
            会社概要
          </h2>
          <div className="w-12 h-px bg-[#C8B99A] mx-auto" />
        </div>

        <div
          ref={tableRef}
          className={`rounded-lg overflow-hidden fade-in ${tableVisible ? 'visible' : ''}`}
          style={{ backgroundColor: '#FEFCFA' }}
        >
          {companyInfo.map((item, i) => (
            <div
              key={item.label}
              className={`flex items-start gap-0 ${i < companyInfo.length - 1 ? 'border-b border-[#EDE4D8]' : ''}`}
            >
              <div
                className="w-36 px-8 py-5 flex-shrink-0 text-sm font-medium tracking-wider"
                style={{ color: '#A8835A', fontFamily: 'Noto Serif JP, serif', backgroundColor: '#F5EEE5' }}
              >
                {item.label}
              </div>
              <div
                className="flex-1 px-8 py-5 text-sm text-[#3A2E28] leading-relaxed"
                style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
              >
                {item.value}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
